var styleDataHash = '55ff5886';  
export const injectCss = (() => {
  var css = `.KMBvr{box-sizing:border-box;height:29px;margin:0 auto;max-width:100%;padding-top:14px;width:100%}.wJ3Mg{padding-top:11px}.skvB6{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}.WlvJS,._1iuSc,.jAO8R,.nsP4h{height:100%}.nsP4h{stroke-dasharray:4 4}.jAO8R{stroke-dasharray:1 5}.WJBpu{width:10%}.phST-{width:40%}._5EB8w{width:100%}.ZsYjW{margin-right:auto}.H5S99{margin:0 auto}.gG4oD{margin-left:auto}.BHCi0{height:100%}.BHCi0 .-rVLb{height:1px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





